import * as React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';

import { Button } from '@/components/atoms/button';

interface ListPageLayoutProps {
  title: string;
  description?: string;
  createHref?: string;
  createLabel?: string;
  actions?: React.ReactNode;
  filters?: React.ReactNode;
  children: React.ReactNode;
}

export function ListPageLayout({
  title,
  description,
  createHref,
  createLabel = 'Créer',
  actions,
  filters,
  children,
}: ListPageLayoutProps) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {description && (
            <p className="text-muted-foreground mt-1">{description}</p>
          )}
        </div>
        <div className="flex items-center gap-2">
          {actions}
          {createHref && (
            <Button asChild>
              <Link to={createHref}>
                <Plus className="mr-2 size-4" />
                {createLabel}
              </Link>
            </Button>
          )}
        </div>
      </div>

      {/* Filters */}
      {filters && <div className="flex flex-wrap gap-4">{filters}</div>}

      {/* Content */}
      {children}
    </div>
  );
}
